<section class="google-workspace-complete-solutions">
  <div class="box">
    <div class="box-content">
      <h3 class="box-content__heading">
        <span>{{ 'GOOGLE_WORKSPACE.COMPLETE_SOLUTIONS.HEADING' | translate }}</span>
      </h3>
      <div class="box-content__menu desktop">
        <ng-container *ngFor="let item of mockContent; let i = index">
          <div class="box-content__menu--nav">
            <div class="nav-bar" [ngClass]="{ active: currentSlide === i + 1 }" (click)="goToSlide(i + 1)">
              <span>{{ item.navigation | translate }}</span>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="box-content__navigation mobile">
        <button class="navigation-btn" (click)="actionClickSlide(actionTypeEnum.prev)"
          ><i class="fas fa-arrow-left"></i
        ></button>

        <ng-container *ngFor="let item of mockContent; let index = index">
          <div
            class="navigation-content"
            *ngIf="currentSlide === index + 1"
            [ngClass]="{ active: currentSlide === index + 1 }"
          >
            <span>{{ item.navigation | translate }}</span>
          </div>
        </ng-container>

        <button class="navigation-btn" (click)="actionClickSlide(actionTypeEnum.next)"
          ><i class="fas fa-arrow-right"></i
        ></button>
      </div>
    </div>
    <div class="box-wrapper">
      <div class="box-wrapper__navigation desktop">
        <button class="navigation-btn" (click)="actionClickSlide(actionTypeEnum.prev)"
          ><i class="fas fa-arrow-left"></i
        ></button>
      </div>
      <div class="box-wrapper__block">
        <ng-container *ngFor="let item of mockContent; let i = index">
          <div
            class="box-wrapper__block--element"
            *ngIf="currentSlide === i + 1"
            [ngClass]="{ slide: currentSlide === i + 1 }"
          >
            <div class="element-left">
              <div class="element-left__text">
                <div class="text-icon">
                  <ng-container *ngFor="let icon of item.icon">
                    <img [src]="getImageUrl(icon)" class="text-icon__image" [alt]="icon" loading="lazy" />
                  </ng-container>
                </div>
                <div class="text-title">
                  <span>{{ item.title | translate }}</span>
                </div>
                <div class="text-detail">
                  <span [innerHTML]="item.detail | translate"></span>
                </div>
              </div>
            </div>
            <div class="element-right">
              <div class="element-right__img">
                <picture>
                  <source [srcset]="item.imageWebp" type="image/webp" />
                  <img [src]="item.image" [alt]="item.navigation | translate" loading="lazy" class="img-layout" />
                </picture>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="box-wrapper__dot">
          <ng-container *ngFor="let slide of mockContent; let index = index">
            <div class="dot" [ngClass]="{ active: currentSlide === index + 1 }"> </div>
          </ng-container>
        </div>
      </div>
      <div class="box-wrapper__navigation desktop">
        <button class="navigation-btn" (click)="actionClickSlide(actionTypeEnum.next)"
          ><i class="fas fa-arrow-right"></i
        ></button>
      </div>
    </div>
  </div>
</section>
